import type { AuthenticationMethod } from '@adornis/authentication/core/authentication-methods.js';
import { defineAuthenticationMethods } from '@adornis/authentication/core/authentication-methods.js';
import type { InitializedAuthentication } from '@adornis/authentication/core/init-authentication.js';
import { initAuthentication } from '@adornis/authentication/core/init-authentication.js';
import { createPasswordAuthenticationMethod } from '@adornis/authentication/methods/password.js';
import { baseConfig } from '@adornis/config/baseConfig.js';
import type { MongoDBDatalayer } from '@adornis/mongodb/server/MongoDBDatalayer.js';
import type { AdornisUser } from '@adornis/users/db/a-user.js';
import { User } from '../entities/user.js';

type Authentication = InitializedAuthentication<readonly AuthenticationMethod[]>;

let authentication: Authentication | undefined;

export const initBuchungsheldAuthentication = async (mongoDBDatalayer?: MongoDBDatalayer): Promise<Authentication> => {
  if (authentication) return authentication;

  // Only the server branch reads the datalayer, and every server startup passes it in.
  const datalayer = mongoDBDatalayer as MongoDBDatalayer;
  authentication = await initAuthentication<readonly AuthenticationMethod[]>({
    mongoDBDatalayer: datalayer,
    methods: defineAuthenticationMethods([
      createPasswordAuthenticationMethod({
        mongoDBDatalayer: datalayer,
        supportedIntents: ['login'],
        defaultUserClass: User as unknown as typeof AdornisUser,
      }),
    ]),
    authenticationOrigin: new URL(baseConfig.get('ROOT_URL')).origin,
    authenticationPagePath: '/',
  });
  return authentication;
};

export const getBuchungsheldAuthentication = (): Authentication => {
  if (!authentication) throw new Error('initBuchungsheldAuthentication() has not run yet');
  return authentication;
};
